import "./footer.css";
import { Link } from "react-router-dom";
import Team from "./Team";
const Footer = () => {
  return (
    <>
      <div class="about">
        <div class="blog-section">
          <p className="lang">
            <h2>A Game da Mata Media</h2>
            <p>
              Barka da zuwa Mata Media, kafar yaɗa labarai ta mata zalla ta
              farko a Najeriya wadda aka samar don kambama muryoyin mata a
              arewacin Najeriya da ma sauran sassan ƙasar. Mata Media, wadda ita
              ce kafar yaɗa labarai irinta ta farko a kasar, ta himmatu wajen
              samar da wani dandali da ake girmama labaran mata da damuwowinsu
              da nasarorinsu da sauran labaran da suka shafi al’umma daga
              mahangar mata.
            </p>

            <p>
              Manufarmu ita ce ƙarfafa wa mata gwiwa ta hanyar aikin jarida
              domin samar da ingantattun labarai da rahotanni wadanda suka dace
              cikin harshen Hausa da kuma bayyana hakikanin nasarori da
              gwagwarmayar da mata a Arewacin Najeriya.{" "}
            </p>
            <p>
              Har ila yau, Mata Media wani waje ne na bai wa mata ‘yan jarida
              horo da jagorantarsu wajen saita rayuwarsu a bigire mai kyau da
              samar musu yanayi mai aminci don yin aiki da haɓaka
              ƙwarewarsu.{" "}
            </p>
            <p>
              Manufarmu ita ce mu samar da wani tsari na yaɗa labarai da za su
              wakilci mata. Muna da nufin tabbatar da cewa duk wani labari da za
              mu bayar ya yi la’akari da irin abubuwa na musamman da mata ke
              fuskanta, kama daga sanya fahimtar mata a fannin manufofin kasa
              kamar yadda kasafin kudin gwamnati zai shafe su kai-tsaye ko rawar
              da suke takawa a siyasa ko kuma yadda suke yin zaɓuka da ma sauran
              batutuwan da suka shafi rayuwarsu ta yau da kullum.
            </p>
            <p>
              A Mata Media, mun yi imani da ƙarfin ba da labari don haifar da
              sauyi da samar da al'umma mai adalci. Ku kasance tare da mu yayin
              da muke daukaka muryoyin mata da kuma ba da gudunmawar gina
              al’umma a Najeriya.
            </p>
            <p>
              Wasu ƙwararru kuma gogaggu a fannin yaɗa labarai waɗanda suka yi
              aiki da kafafen labarai na gida da na kasashen waje daban-daban ne
              suka kafa Mata Media. Mutane ne da suke da ilimi da gogewa kan
              buƙatun da ake da su na labarai a Najeriya da ma wajenta, musamman
              sanin abin da masu sauraro suka fi son samu a kasuwar yaɗa labarai
              ta Arewacin Najeriya.
            </p>
          </p>

          <p className="lang">
            <h2>About Mata Media</h2>
            <p>
              Welcome to Mata Media, Nigeria’s pioneering all-women newsroom
              dedicated to amplifying the voices of women in northern Nigeria
              and beyond. As the first media organization of its kind in the
              country, Mata Media is committed to providing a platform where
              women’s stories, concerns, and perspectives are at the forefront
              of public discourse.
            </p>

            <p>
              Our mission is to empower women through journalism by producing
              high-quality content in Hausa that resonates with and reflects the
              realities of women in northern Nigeria. We focus on issues that
              matter most to women—covering news and current affairs ranging
              from social challenges, women’s rights, economic developments,
              climate change, environment, health and cultural topics—always
              with a lens that highlights their impact and significance.
            </p>
            <p>
              Mata Media is a digital-only platform initially, with plans to
              expand to conventional platforms to reach a broader audience. Our
              content includes reports, explainers, news, talk shows, and
              documentaries, all crafted to inform, educate, and inspire. We
              also serve as a nurturing space for young female journalists
              across Nigeria, providing mentorship, training, and a safe
              environment to develop their skills and thrive in the profession.
            </p>
            <p>
              Our goal is to foster an inclusive media landscape where women
              feel represented and heard. We aim to ensure that every story we
              tell considers the unique experiences of women, whether it’s
              analyzing national policies like the budget from a women’s
              perspective, political participation, election matters or
              highlighting issues that affect their daily lives.
            </p>
            <p>
              At Mata Media, we believe in the power of storytelling to drive
              change and create a more equitable society. Join us as we elevate
              women’s voices and contribute to a more inclusive and informed
              Nigeria.
            </p>
            <p>
              Mata Media is established by a group of experienced and talented
              media professionals who have worked with various local and
              international organizations and are knowledgeable about news needs
              in Nigeria and beyond, especially in the northern Nigerian market.
            </p>
          </p>
        </div>
        <Team />
      </div>
    </>
  );
};

export default Footer;
